var Backbone, EmailFormUSLocationElementView, SupportLocationElementTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportLocationElementTemplate = require('../../../../location_element_view.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

EmailFormUSLocationElementView = (function(superClass) {
  extend(EmailFormUSLocationElementView, superClass);

  function EmailFormUSLocationElementView() {
    return EmailFormUSLocationElementView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSLocationElementView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.template = SupportLocationElementTemplate;
    return _.bindAll.apply(_, [this].concat(_.functions(this)));
  };

  EmailFormUSLocationElementView.prototype.events = {
    'change .add': 'onChangeSelection'
  };

  EmailFormUSLocationElementView.prototype.render = function() {
    return this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  EmailFormUSLocationElementView.prototype.toHash = function() {
    var locObj;
    locObj = this.options.location;
    if (locObj.isSelected) {
      locObj.checked = "checked";
    } else {
      locObj.checked = "";
    }
    locObj.address = locObj.streetAddress1 + "," + locObj.city + "," + locObj.state + "," + locObj.postalCode;
    return locObj;
  };

  EmailFormUSLocationElementView.prototype.onChangeSelection = function() {
    this.options.location.isSelected = !this.options.location.isSelected;
    return this.options.cb.call();
  };

  return EmailFormUSLocationElementView;

})(Backbone.View);

module.exports = EmailFormUSLocationElementView;

//# sourceMappingURL=data:application/json;base64,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
